angular.module('zc.zenclerkS')
  .component('zcsChartPie', {
    bindings: {
      chartData: '<',
      chartOptions: '<',
      redrawPieChart: '=?',
    },
    controller: zcsChartPieController
  });

zcsChartPieController.$inject = ['$element'];
function zcsChartPieController($element) {
  const vm = this;
  const container = angular.element('zcs-chart-pie');
  const svgContainer = d3.select($element[0]).append('svg');
  const chart = nv.models.pieChart();
  const colors = getChartColors();
  let isDrawn = false;

  vm.$onChanges = changes => {
    // do not react to dimension changes
    if(vm.redrawPieChart || !isDrawn && changes.chartData) {
      drawChart();
    }
  };

  function getChartColors() {
    const chartClassNames = [
      'chart-primary',
      'chart-secondary',
      'chart-tertiary',
    ];
    return _.map(chartClassNames, className => {
      container.append(`<div class="${className}">`);
      return angular.element(`.${className}`).css('color');
    });
  }

  // Draw a pie chart
  function drawChart() {
    nv.addGraph(function() {
      chart.showLabels(false)
        .showLegend(false)
        .color(colors)
        .x(d => d.label)
        .y(d => d.value);

      // Apply user given chart option if they exist.
      // For example, option like this:
      // {
      //   "margin": {
      //     "top": 30,
      //     "left": 0,
      //     "right": 0
      //   }
      // }
      //
      // Would be applied like this:
      // chart.margin({
      //     "top": 30,
      //     "left": 0,
      //     "right": 0
      //   })
      _.each(_.keys(vm.chartOptions), option => {
        if(_.isFunction(chart[option])) {
          const optionValue = _.get(vm.chartOptions, option);
          chart[option](optionValue);
        }
      });

      svgContainer.datum(vm.chartData)
        .transition()
        .duration(350)
        .call(chart);

      nv.utils.windowResize(chart.update);
      return chart;
    });
    isDrawn = true;
    vm.redrawPieChart = false;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/charts/chart_pie.js